import React, { useCallback } from 'react';
import Tippy from 'utils/Tippy';
import ServiceTag, { SKINS } from 'components/ServiceTag';

import { CopyableText } from 'modules/Common/Copy';
import { IS_TENANT } from 'tenant/config';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

const SOLink = styled.div`
  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
`;

const t = {
  prio: 'Prio',
  ftb: 'FTB',
  recovering: 'Recovering',
};

const shipperClass = (itinerary, shipperOrder) => {
  if (!itinerary?.upgrade_journey || !!shipperOrder?.from_upgrade_journey) {
    return 'shipper';
  }

  return 'shipper upgrade';
};

const ShippersTooltip = ({
  className,
  itinerary,
  shipperOrders = [],
  children,
  trigger = 'click',
  placement = 'bottom',
}) => {
  const shipperOrderList = itinerary?.shipper_orders || shipperOrders || [];
  const history = useHistory();

  const navigateToSODetail = useCallback(
    (shipperOrder) => {
      history.push(`/queued/${shipperOrder.id}`);
    },
    [history]
  );

  const content = (
    <div className="list">
      {shipperOrderList.map((shipperOrder, key) => (
        <div
          className={shipperClass(itinerary, shipperOrder)}
          key={shipperOrder?.id}
          data-testid={`shipperOrder(${shipperOrder?.id})`}
        >
          <div className="shipper__company_name">
            {/* regular behavior for non tenant (copy order id to clipboard) */}
            {!!shipperOrder.id && !IS_TENANT && (
              <div className="shipper__order_id">
                <CopyableText text={`S${shipperOrder.id}`} />
              </div>
            )}
            {/* tenant behavior (navigate to order detail)  */}
            {!!shipperOrder.id && IS_TENANT && (
              <div className="shipper__order_id">
                <SOLink
                  onClick={() => {
                    navigateToSODetail(shipperOrder);
                  }}
                >
                  {`S${shipperOrder.id}`}
                </SOLink>
              </div>
            )}
            {shipperOrder?.shipper?.company_name}
          </div>
          <div className="shipper__tags">
            {shipperOrder?.shipper?.is_prio && (
              <ServiceTag text={t.prio} skin={SKINS.primary} textTransform="uppercase" />
            )}
            {shipperOrder?.shipper?.is_ftb && (
              <ServiceTag text={t.ftb} skin={SKINS.success} textTransform="uppercase" />
            )}
            {shipperOrder?.shipper?.is_recovering && (
              <ServiceTag text={t.recovering} skin={SKINS.accent} textTransform="uppercase" />
            )}
          </div>
        </div>
      ))}
    </div>
  );

  if (!!shipperOrderList.length) {
    return (
      <>
        <Tippy
          placement={placement}
          appendTo={document.body}
          content={content}
          theme="light"
          className={className}
          interactive
          trigger={trigger}
        >
          {children}
        </Tippy>
      </>
    );
  }

  return children;
};

export default ShippersTooltip;
